import React from 'react';
import { DataTableDialog } from '@features/data-table/dialog';
import { DataTablesList } from '@features/data-table/list';
import { DataTableViewFooter } from './DataTableViewFooter';
import { MainLayout } from '@ui/layout';

export const DataTablesView: React.FC = () => {
  return (
    <MainLayout>
      <MainLayout.Content>
        <DataTablesList />
        <DataTableDialog />
        <DataTableViewFooter />
      </MainLayout.Content>
    </MainLayout>
  );
};

export default DataTablesView;
